"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REFUND_DECISION_NOTE_MAX_LENGTH = exports.REFUND_REQUEST_REASON_MAX_LENGTH = exports.FEEDBACK_ATTACHMENT_PREVIEW_TEXT = exports.FEEDBACK_ATTACHMENT_MIME_TYPES = exports.FEEDBACK_ATTACHMENT_MAX_DIMENSION = exports.FEEDBACK_ATTACHMENT_MAX_BYTES = exports.FEEDBACK_ATTACHMENT_MAX_COUNT = exports.FEEDBACK_ATTACHMENTS_FIELD = exports.FEEDBACK_AUTO_REPLY_MAX_LENGTH = exports.DEFAULT_FEEDBACK_AUTO_REPLY_MESSAGE = exports.VENUE_SUGGESTION_AUTO_REPLY_MAX_LENGTH = exports.DEFAULT_VENUE_SUGGESTION_AUTO_REPLY_MESSAGE = exports.VENUE_SUGGESTION_NAME_MAX_LENGTH = exports.APP_STORE_REVIEW_RESPONSE_MAX_LENGTH = exports.SUPPORT_NAME_MAX_LENGTH = exports.DEFAULT_SUPPORT_NAME = exports.FEEDBACK_REPLY_MAX_LENGTH = exports.FEEDBACK_MESSAGE_MAX_LENGTH = exports.FEEDBACK_SUBJECT_MAX_LENGTH = exports.FEEDBACK_ACTIVE_TOPIC_LIMIT = void 0;
exports.FEEDBACK_ACTIVE_TOPIC_LIMIT = 5;
exports.FEEDBACK_SUBJECT_MAX_LENGTH = 120;
exports.FEEDBACK_MESSAGE_MAX_LENGTH = 4000;
exports.FEEDBACK_REPLY_MAX_LENGTH = 4000;
exports.DEFAULT_SUPPORT_NAME = 'Ivy Support';
exports.SUPPORT_NAME_MAX_LENGTH = 100;
exports.APP_STORE_REVIEW_RESPONSE_MAX_LENGTH = 4000;
exports.VENUE_SUGGESTION_NAME_MAX_LENGTH = 120;
exports.DEFAULT_VENUE_SUGGESTION_AUTO_REPLY_MESSAGE = "Thanks for the suggestion! We'll take a look and follow up here.";
exports.VENUE_SUGGESTION_AUTO_REPLY_MAX_LENGTH = 1000;
/** First admin reply auto-posted on newly created *general* feedback topics (venue suggestions have their own toggle above). */
exports.DEFAULT_FEEDBACK_AUTO_REPLY_MESSAGE = "Thanks for reaching out! We'll take a look and follow up here.";
exports.FEEDBACK_AUTO_REPLY_MAX_LENGTH = 1000;
/** Image attachments on feedback messages (the opening message or any reply, user or admin). */
exports.FEEDBACK_ATTACHMENTS_FIELD = 'attachments';
exports.FEEDBACK_ATTACHMENT_MAX_COUNT = 4;
exports.FEEDBACK_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024;
/** Longest side after server-side processing; smaller images are never upscaled. */
exports.FEEDBACK_ATTACHMENT_MAX_DIMENSION = 2048;
exports.FEEDBACK_ATTACHMENT_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
/** Preview text for a message that has attachments but no text. */
exports.FEEDBACK_ATTACHMENT_PREVIEW_TEXT = 'Photo';
/** Optional reason a user gives when asking for a ticket refund (also the feedback topic's opening message). */
exports.REFUND_REQUEST_REASON_MAX_LENGTH = 1000;
/** Admin note sent to the user when approving / declining a refund. */
exports.REFUND_DECISION_NOTE_MAX_LENGTH = 1000;
//# sourceMappingURL=feedback.js.map